/**
 * Created by Ivan on 10.08.2026
 */

const PuzzlesComponent2 = function (collection) {
    return Prefab.instantiate(bundles.stickers2_collection_window.jsons.puzzles_component_prefab_json, { collection });
};
